import classnames from 'classnames';
import React from 'react';
import { IBaseLayerViewProps } from '@/version-types';

/**
 * 基础图层渲染
 */
export const BaseLayerView = React.forwardRef<HTMLDivElement, IBaseLayerViewProps & { children?: React.ReactNode }>(
    (
        {
            /** 图层数据 */
            layer,
            /** 是否是预览图 */
            isNavigator = false,
            // 禁用图层事件
            // 背景、主图需要禁用
            disableEvents = false,
            // 内容超出隐藏
            isOverflowHidden = false,
            /** 内容容器样式 */
            layerContentChildrenWrapStyle = {},
            children,
            disableReactiveArea = false,
            maskStyle = {},
        },
        ref,
    ) => {
        const { id, width, height, left, top, rotate, parentId } = layer;

        const hasReactiveArea = !disableReactiveArea && (width < 100 || height < 100) && !parentId;

        return (
            <div
                ref={ref}
                className={classnames('layer-view', {
                    'disable-event': disableEvents || isNavigator,
                })}
                data-layer-type={layer.layerType}
                data-layer-id={`${id}${hasReactiveArea ? '-parent' : ''}`}
                data-layer-parent-id={parentId || ''}
                style={{
                    width,
                    height,
                    transform: `translate(${left}px, ${top}px) rotate(${rotate}deg)`,
                    // image 的mask跟transform同一层 解决mask有1px黑边问题
                    ...maskStyle,
                }}
            >
                {hasReactiveArea && (
                    <div
                        className="reactive-area"
                        data-layer-id={id}
                        style={{
                            width: width < 100 ? width + 40 + 'px' : '100%',
                            height: height < 100 ? height + 40 + 'px' : '100%',
                            left: width < 100 ? '-20px' : '0',
                            top: height < 100 ? '-20px' : '0',
                        }}
                    ></div>
                )}

                <div
                    className={classnames('layer-view__content', {
                        'overflow-hidden': isOverflowHidden,
                    })}
                    style={{ ...layerContentChildrenWrapStyle }}
                >
                    {children}
                </div>
            </div>
        );
    },
);
